import { useCallback, useEffect, useState } from "react";
import { Button, Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import ReactDataGrid from "@inovua/reactdatagrid-community";
import { LoadShiplistData } from "./LoadShiplistData";
import { ImFilePdf } from "react-icons/im";
import { exportPDF_shiplists } from "../excelExport";

const Shiplists = () => {
  //----- GET CURRENT USER -----//
  const tokenString = sessionStorage.getItem("token");
  const userToken = JSON.parse(tokenString);
  const UserID = userToken.userId;

  const [dataSource, setDataSource] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  //Store reference to grids for exporting PDF
  const [gridRef_shiplist, setGridRef_shiplist] = useState(null);

  //Sets data for the rows that are checked
  const [selected, setSelected] = useState();

  // Sets datasource on load and when searchString changes
  useEffect(() => {
    async function fetchData() {
      try {
        const data = await LoadShiplistData(UserID);
        setDataSource(data.data);
        data.data.length > 0 ? setDisabled(false) : setDisabled(true);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchData();
  }, [UserID]);

  const columns = [
    { name: "OrderNo", header: "OrderNo", type: "string", defaultFlex: 0 },
    { name: "Name", header: "Name", type: "string", defaultFlex: 1 },
    { name: "Qty", header: "Qty", type: "string", defaultFlex: 0 },
    { name: "Lines", header: "Lines", type: "string", defaultFlex: 0 },
    { name: "Site", header: "Site", type: "string", defaultFlex: 0 },
  ];

  // Styles and setup for grid
  const gridStyle = {
    minHeight: "83vh",
    margin: 10,
  };

  const theme = "default-dark";

  const handleCopyToClipboard = (data) => {
    //alert('Copied Data : '+JSON.stringify(data));
    navigator.clipboard.writeText(data);
  };

  // Context menu for stock grid, to allow copying of data such as product number
  const renderRowContextMenu = useCallback((menuProps, { rowProps }) => {
    menuProps.autoDismiss = true;
    menuProps.items = [
      {
        label: "Copy Order Number",
        onClick: () => handleCopyToClipboard(rowProps.data.OrderNo),
      },
      {
        label: "Copy Name",
        onClick: () => handleCopyToClipboard(rowProps.data.Name),
      },
    ];
  }, []);

  // Handle row click
  const onSelectionChange = useCallback(({ selected }) => {
    if (selected !== true) {
      setSelected(selected);

      if (Object.keys(selected).length > 0) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    }
    //console.log(JSON.stringify(toArray(selected)));
    // console.log(selected)
  }, []);

  const confirmShiplists = async (data) => {
    const userId = UserID;
    const url = `/confirmShiplists/${userId}`;
    const orderNums = Object.keys(data);

    try {
      // post request
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(orderNums),
      });

      if (response.status !== 200) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      setShowSuccessModal(true);

      // Reload table
      try {
        const data = await LoadShiplistData(userId);
        setDataSource(data.data);
        // console.log("data", data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } catch (error) {
      return console.error("Error:", error);
    }
  };

  return (
    <>
      <div className="stock-container">
        <div className="container mt-4 d-flex justify-content-end">
          <div className="">
            {/* Confirm button */}
            <OverlayTrigger
              key="CONFIRMSHIPLISTS"
              placement="bottom"
              overlay={<Tooltip id="tooltip-pdf">Confirm</Tooltip>}
            >
              <Button
                variant="success"
                style={{
                  margin: "5px",
                  marginTop: "0px",
                  // border: "1px solid black",
                }}
                onClick={() => {
                  setShowConfirmModal(true);
                }}
                disabled={disabled}
              >
                Confirm
                {/* <RiSave2Fill /> */}
              </Button>
            </OverlayTrigger>
            {/* Export to PDF (Shiplists Grid) */}
            <OverlayTrigger
              key="PDFEXPORT"
              placement="bottom"
              overlay={<Tooltip id="tooltip-pdf">Table to PDF</Tooltip>}
            >
              <Button
                variant="secondary"
                style={{
                  margin: "5px",
                  marginTop: "0px",
                  border: "1px solid black",
                }}
                onClick={() => {
                  const gridData = gridRef_shiplist;
                  exportPDF_shiplists(gridData);
                }}
                disabled={disabled}
              >
                <ImFilePdf />
              </Button>
            </OverlayTrigger>
          </div>
        </div>

        <div className="grid-container">
          <div className="stock-grid">
            <ReactDataGrid
              idProperty="OrderNo"
              columns={columns}
              dataSource={dataSource}
              style={gridStyle}
              theme={theme}
              selected={selected}
              checkboxColumn
              onSelectionChange={onSelectionChange}
              renderRowContextMenu={renderRowContextMenu}
              // defaultSortInfo={defaultSortInfo}
              handle={setGridRef_shiplist}
            />
          </div>
        </div>
      </div>

      {/* Confirm Modal */}
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>You are about to confirm shiplists.</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={() => {
              setSelected({});
              confirmShiplists(selected);
              setDisabled(true);
              setShowConfirmModal(false);
            }}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Success Modal */}
      <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Ship Lists Confirmed</Modal.Title>
        </Modal.Header>
        <Modal.Body>Shiplists have been confirmed.</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowSuccessModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Shiplists;
